export default __webpack_public_path__ + "static/lsa-screens-1-eeb7149a5237d2d96efd67b4c65a9b80.jpg";